// extracted by mini-css-extract-plugin
export default {"zoomModal":"v3-z"};